export enum QueryParam {
  RedirectUrl = 'redirectUrl'
}
